exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".analytics{margin-top:20px}.analytics .chart-container{margin-bottom:20px}.analytics .panel{margin-top:0}.analytics .analytics-widget{background:#fff;padding:20px;border-radius:3px;margin-bottom:20px}.analytics .analytics-widget .icon{width:60px;height:60px;display:inline-block;line-height:60px!important;text-align:center;font-size:3.5rem;border-radius:100%;float:left;margin-right:10px;color:#fff}.analytics .analytics-widget .info{font-size:1.3rem}.analytics .analytics-widget .info .title{display:block;font-size:2.1rem;font-weight:600}.analytics .profit-graph-container .profit-graph-scroll{font-size:1.1rem;height:300px;overflow-y:scroll}.analytics .profit-graph-container .btn-group .btn{margin-top:5px;margin-right:10px}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./src/css/Analytics.less
 ** module id = 770
 ** module chunks = 0
 **/